<template>
  <el-input
    :placeholder="this.$t('iDalgoLists.searchBar')"
    v-model="mySearch"
    ref="searchInput"
    class="searchBar"
    clearable>
    <svgicon slot="prefix" name="search"></svgicon>
  </el-input>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import '@/components/icons'

export default {
  name: 'iDalgo-Template-Search',
  computed: {
    ...mapGetters({
      search: 'templates/search'
    }),
    mySearch: {
      get () {
        return this.search
      },
      set (value) {
        // update search value in store
        this.$store.commit('templates/SEARCH_UPDATED', value)
        // when finished typing, update the route
        this.updateRouteAfterTyping(this, value)
      }
    }
  },
  methods: {
    updateRoute (page = 1, search) {
      // add a parameter 'search' if search has a value
      let query = {
        page: 1
      }
      if (search !== '') {
        query.search = search
      }
      // update the route with the new parameters
      this.$router.push({ name: 'templates', query })
    },
    // update the route depending on the page and the search string
    updateRouteAfterTyping: debounce((ctx, search = '') => {
      ctx.updateRoute(ctx.$route.query.page, search)
    }, 400)
  },
  mounted () {
    if (this.$route.query.search) {
      this.mySearch = this.$route.query.search
    }
  }
}
</script>

<style lang="scss">
.searchBar {
  input {
    padding-right: 30px !important;
    font-size: 17px !important
;
    font-family: 'robotoregular';
    &::placeholder,  { /* Chrome, Firefox, Opera, Safari 10.1+ */
      font-family: 'robotomedium';
      color: $medium-gray !important;
    }
    &::-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-family: 'robotomedium';
      color: $medium-gray !important;
    }
    &::-ms-input-placeholder { /* Microsoft Edge */
      font-family: 'robotomedium';
      color: $medium-gray !important;
    }
  }

  .el-input__prefix {
    height: 15px;
    width: 15px;
    left: 26px;
    top: 8px;
    svg {
      width: 15px;
      height: 15px;
      color: #DDDDE3;
    }
  }
}

</style>

<style lang="scss" scoped>
svg {
  color: $medium-gray !important;
}

input {
  padding-left: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Template-Search.vue